// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Row, Col, OrganizationHierarchyTree } from "@components";
import HierarchyScopeAreasIncluded from "./hierarchy-scope-areas-included";
import HierarchyScopeExcludedAreas from "./hierarchy-scope-areas-excluded";
import type { HierarchyAssignment } from "@modules/service/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import * as transformers from "./transformers";

import "./hierarchy-scope.scss";

type OwnProps = $Exact<{
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
}>;

type Props = OwnProps & PropsFromLocalize;

export const HierarchyScopeView = (props: Props) => (
  <Row>
    <Col sm={4}>
      <div className="hs__container">
        {props.hierarchy ? (
          <OrganizationHierarchyTree
            tree={props.hierarchy}
            expanded={[]}
            disabled={true}
            selected={transformers.getSelectedIds(props.assignments)}
            excluded={transformers.getExcludedIds(props.assignments)}
            searchable={true}
            searchPlaceholder={props.t("HIERARCHY_SCOPE_FIND_DEPARTMENTS")}
            onAction={() => {
              /* Prop is not optional but I do not use it.  Needs removing in different PR */
            }}
            onDrop={() => {
              /* Prop is not optional but I do not use it.  Needs removing in different PR */
            }}
          />
        ) : null}
      </div>
    </Col>
    <Col sm={8}>
      <div className="mb-3">
        <HierarchyScopeAreasIncluded assignments={props.assignments} editing={false} />
      </div>
      <div className="mb-3">
        <HierarchyScopeExcludedAreas assignments={props.assignments} editing={false} />
      </div>
    </Col>
  </Row>
);

export default localize()(HierarchyScopeView);
